{
  "dashboard": {
    "toReceive": "Deliveries to receive",
    "countsFailed": "Could not load: {{names}}",
    "attentionTitle": "Needs attention",
    "attentionAlert": "Overdue or late now",
    "managementTitle": "Analytics",
    "progressTitle": "Progress",
    "period": {
      "window": "Last 12 months",
      "now": "Now",
      "budgetPeriod": "Current budget period"
    },
    "scopeNodes_zero": "No purchasing units",
    "scopeNodes_one": "{{count}} purchasing unit",
    "scopeNodes_two": "{{count}} purchasing units",
    "scopeNodes_few": "{{count}} purchasing units",
    "scopeNodes_many": "{{count}} purchasing units",
    "scopeNodes_other": "{{count}} purchasing units",
    "reportingNotIncluded": "Reporting is not included for your organisation",
    "reportingNotIncludedBody": "Your organisation's agreement with Fidelen does not include reports, so its figures and charts are not shown. Your own work is below.",
    "figuresFailed": "Your organisation's figures could not be loaded.",
    "overdueValue": "Overdue: {{value}}",
    "onBehalfValue": "On behalf of others: {{value}}",
    "lateValue": "Late: {{value}}",
    "lateDeliveries": "Late deliveries",
    "queues": {
      "inProgress": "In progress",
      "returned": "Returned to you",
      "drafts": "Drafts",
      "toReview": "Requests to review",
      "toSource": "Needs sourcing",
      "openRfqs": "Open enquiries",
      "toSend": "Orders to send",
      "supplierQueries": "Supplier queries",
      "supplierDeclined": "Declined by supplier",
      "renewals": "Agreements due for renewal",
      "qualifications": "Qualifications to decide"
    },
    "decisionContext": "Budget and exceptions",
    "decisionsFailed": "The decisions waiting on you could not be loaded.",
    "withHolder": "With",
    "nextDeliveries": "Next deliveries",
    "nextDeliveriesHint": "Soonest expected first",
    "noDeliveries": "No deliveries are waiting to be received.",
    "deliveriesFailed": "The deliveries waiting could not be loaded.",
    "openReceiving": "Open receiving",
    "late": "Late",
    "requestsTrendTitle": "Requests raised, by month",
    "requestsTrendSummary": "Requests raised in each month of the last 12, oldest first. The current month is to date.",
    "requestsSeries": "Requests raised",
    "noRequestsInWindow": "No requests were raised in the last 12 months.",
    "valueTrendTitle": "Committed and received, by month",
    "valueTrendSummary": "Value committed on orders issued, and value received, in each month of the last 12, oldest first, per currency. The current month is to date.",
    "committedSeries": "Committed",
    "receivedSeries": "Received",
    "noValueInWindow": "Nothing was committed or received in the last 12 months.",
    "currencyColumn": "Currency",
    "categoryColumn": "Category",
    "orderedColumn": "Ordered",
    "spendSummary": "Ordered value over the last 12 months, grouped as chosen: the five largest and the rest together, per currency.",
    "budgetSummary": "The {{shown}} budgets nearest or over their limit, of {{total}} in the current period.",
    "viewAllBudgets": "View all budgets",
    "budgetColumn": "Budget",
    "allocatedColumn": "Allocated",
    "utilisationColumn": "Used",
    "healthColumn": "Position",
    "executionTitle": "Purchase-order execution",
    "executionSummary": "Orders open, late and partly received now, and deliveries on time over the last 12 months.",
    "byFulfilment": "Open orders by delivery",
    "byResponse": "Open orders by supplier response",
    "notMeasured": "Not measured yet",
    "openReport": "Open report",
    "figureColumn": "Figure",
    "valueColumn": "Value",
    "periodColumn": "Period",
    "groupColumn": "Breakdown",
    "otherStatuses": "Other",
    "otherHolders": "Other holders",
    "workloadTitle": "Approval workload",
    "workloadSummary": "Decisions waiting at their current level: within SLA, overdue or with no SLA; how long they have waited; and who holds them.",
    "workloadUnavailable": "Approval workload figures are not available yet.",
    "nothingWaiting": "No decision is waiting.",
    "bySla": "By SLA",
    "byAge": "By time waiting",
    "byHolder": "By holder",
    "sla": {
      "within_sla": "Within SLA",
      "overdue": "Overdue",
      "no_sla": "No SLA set"
    },
    "latestFailed": "Your latest requests could not be loaded.",
    "exceptionsTitle": "Receiving exceptions by type",
    "exceptionsSummary": "Receiving exceptions recorded in the last 12 months, by type.",
    "spendBy": {
      "category": "Ordered, by category",
      "supplier": "Ordered, by supplier",
      "branch": "Ordered, by purchasing unit"
    },
    "otherGroups": "Other",
    "spendBasisNote": "Ordered value counts the orders issued in the window that were not cancelled.",
    "summaryTitle": "At a glance",
    "operationalQueues": "Operational queues",
    "operationAnalysis": "Operational analysis",
    "noAttention": "No overdue approvals, late orders or receiving exceptions in these figures.",
    "openMyWork": "Open my work",
    "workSummary": "Your decisions, requests and deliveries, grouped by what you can act on.",
    "lifecycleTitle": "Purchase-order lifecycle",
    "lifecycleSummary": "All purchase orders currently in your reporting scope, including drafts and closed orders. Each order appears in one lifecycle state. This is independent of the value trend's date window.",
    "noOrders": "No purchase orders in these figures.",
    "totalOrders": "Total purchase orders",
    "reviewDecision": "Review request"
  },
  "nav": {
    "reference": "Reference data"
  }
}
